import React, { useState } from 'react';
import { Box, Button, Grid, TextField, Typography, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, IconButton } from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';

export const Customer = () => {
    const [customers, setCustomers] = useState([]);
    const [customerDetails, setCustomerDetails] = useState({
        customerId: '',
        name: '',
        email: '',
        phone: '',
        address: '',
    });
    const [editIndex, setEditIndex] = useState(-1);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setCustomerDetails({ ...customerDetails, [name]: value });
    };

    const handleAddCustomer = () => {
        if (editIndex >= 0) {
            const updatedCustomers = [...customers];
            updatedCustomers[editIndex] = customerDetails;
            setCustomers(updatedCustomers);
            setEditIndex(-1);
        } else {
            setCustomers([...customers, customerDetails]);
        }
        setCustomerDetails({
            customerId: '',
            name: '',
            email: '',
            phone: '',
            address: '',
        });
    };

    const handleEdit = (index) => {
        setCustomerDetails(customers[index]);
        setEditIndex(index);
    };

    const handleDelete = (index) => {
        setCustomers(customers.filter((_, i) => i !== index));
    };

    return (
        <Box sx={{ p: 3 }}>
            <Typography variant="h4" gutterBottom>
                Customer Management
            </Typography>

            <Grid container spacing={2}>
                <Grid item xs={12} md={4}>
                    <TextField
                        fullWidth
                        label="Customer ID"
                        name="customerId"
                        value={customerDetails.customerId}
                        onChange={handleChange}
                        required
                    />
                </Grid>
                <Grid item xs={12} md={4}>
                    <TextField
                        fullWidth
                        label="Name"
                        name="name"
                        value={customerDetails.name}
                        onChange={handleChange}
                        required
                    />
                </Grid>
                <Grid item xs={12} md={4}>
                    <TextField
                        fullWidth
                        label="Email"
                        name="email"
                        value={customerDetails.email}
                        onChange={handleChange}
                        type="email"
                        required
                    />
                </Grid>
                <Grid item xs={12} md={4}>
                    <TextField
                        fullWidth
                        label="Phone"
                        name="phone"
                        value={customerDetails.phone}
                        onChange={handleChange}
                        type="tel"
                        required
                    />
                </Grid>
                <Grid item xs={12} md={4}>
                    <TextField
                        fullWidth
                        label="Address"
                        name="address"
                        value={customerDetails.address}
                        onChange={handleChange}
                    />
                </Grid>
                <Grid item xs={12}>
                    <Button
                        variant="contained"
                        color="primary"
                        onClick={handleAddCustomer}
                        sx={{ mt: 2, display: 'block', margin: '0 auto', backgroundColor: 'orange' }}
                    >
                        {editIndex >= 0 ? 'Save Customer' : 'Add Customer'}
                    </Button>
                </Grid>
            </Grid>

            <TableContainer component={Paper} sx={{ mt: 4 }}>
                <Table>
                    <TableHead>
                        <TableRow>
                            <TableCell>Customer ID</TableCell>
                            <TableCell>Name</TableCell>
                            <TableCell>Email</TableCell>
                            <TableCell>Phone</TableCell>
                            <TableCell>Address</TableCell>
                            <TableCell>Actions</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {customers.map((customer, index) => (
                            <TableRow key={index}>
                                <TableCell>{customer.customerId}</TableCell>
                                <TableCell>{customer.name}</TableCell>
                                <TableCell>{customer.email}</TableCell>
                                <TableCell>{customer.phone}</TableCell>
                                <TableCell>{customer.address}</TableCell>
                                <TableCell>
                                    <IconButton onClick={() => handleEdit(index)}>
                                        <EditIcon />
                                    </IconButton>
                                    <IconButton onClick={() => handleDelete(index)} color="error">
                                        <DeleteIcon />
                                    </IconButton>
                                </TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>
        </Box>
    );
};

export default Customer;
